import { defineMessages } from 'react-intl'

export default defineMessages({
  listHeader: {
    id: 'catalogPermissionSecondaryCategoryConfigTable.listHeader',
    defaultMessage: 'Departments',
  },
  searchPlaceholder: {
    id: 'catalogPermissionSecondaryCategoryConfigTable.searchPlaceholder',
    defaultMessage: 'Search departments',
  },
  searchAriaLabel: {
    id: 'catalogPermissionSecondaryCategoryConfigTable.searchAriaLabel',
    defaultMessage: 'Search departments',
  },
  searchButtonAriaLabel: {
    id: 'catalogPermissionSecondaryCategoryConfigTable.searchButtonAriaLabel',
    defaultMessage: 'Search',
  },
  emptyState: {
    id: 'catalogPermissionSecondaryCategoryConfigTable.emptyState',
    defaultMessage: 'No departments found',
  },
  errorState: {
    id: 'catalogPermissionSecondaryCategoryConfigTable.errorState',
    defaultMessage: 'Unable to load departments. Please try again.',
  },
})
